export function getAllQueryParamsInURL(source) {
    const url = source.toLowerCase();
    const firstQuestionMarkIndex = url.indexOf('?');
    const beforeFirstQuestionMark = url.substring(0, firstQuestionMarkIndex + 1);
    const afterFirstQuestionMark = url
        .substring(firstQuestionMarkIndex + 1)
        .split(/[#?]/g)
        .join('&');
    return beforeFirstQuestionMark + afterFirstQuestionMark;
}
export function isValidURL(url) {
    if (typeof url !== 'string') {
        return false;
    }
    try {
        const u = new URL(url);
        return Boolean(u.hostname);
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=url.helper.js.map